import { Menu, MenuItem, styled } from '@mui/material';

export const MenuStyled = styled(Menu)({
    '& .MuiList-root': {
        padding: '16px 0',
        backgroundColor: 'transparent',
    },
});

export const MenuItemStyled = styled(MenuItem)(({ theme }) => ({
    padding: '8px 16px',
    color: theme.palette.mode === 'dark' ? theme.palette.primary.contrastText : theme.palette.text.secondary,

    '&:hover': {
        color: theme.palette.mode === 'dark' ? theme.palette.error.main : theme.palette.primary.main,
        backgroundColor: 'transparent',
    },
}));
